<template>
  <div>
    <WmsTable
      :isPagination="query"
      :hasHeader="false"
      :dataSource="dataSource"
      :columns="realColumns"
    >
      <template slot="action" slot-scope="{ record }">
        <span class="span__btn" @click="edit(record)">编辑</span>
        <span class="line">|</span>
        <span
          class="span__btn"
          :style="`color:${record.isOpen ? 'red' : ''}`"
          @click="close(record)"
          >{{ record.isOpen ? "关闭" : "开启" }}</span
        >
      </template>
    </WmsTable>
    <configDialog
      ref="configDialog"
      :printBusinessType="printBusinessType"
      @overEmit="$emit('overEmit')"
    ></configDialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import configDialog from "./configDialog.vue";
import { columns,columns_pkg, sheetSizeList } from "./InterListData.js";
import { editOpenOrClose } from "@/apis/configure";
export default {
  name: "InterList",
  components: {
    WmsTable,
    configDialog,
  },
  props: {
    dataSource: {
      type: Array,
      default: [],
    },
    printBusinessType: {
      type: Number,
    },
  },
  data() {
    return {
      columns,
      columns_pkg,
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  watch: {},
  computed: {
    realColumns: function () {
      return this.printBusinessType == 2?columns_pkg:columns
    },
  },
  methods: {
    edit(record) {
      let template = { ...record };
      template.size = sheetSizeList.findIndex(
        (item) =>
          item.height == record.printPaperSizeHigh &&
          item.width == record.printPaperSizeWide
      );
      this.$refs.configDialog.open(template);
    },
    close(record) {
      editOpenOrClose({ id: record.id, openFlag: record.isOpen ? 0 : 1 }).then(
        (res) => {
          if (res.success) {
            this.$message.success("成功");
            this.$emit("overEmit");
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.span__btn {
  cursor: pointer;
  padding: 1px 0;
  margin: 2px;
  color: #40a9ff;
}

.line {
  margin: 2px;
  color: #40a9ff;
  position: relative;
  top: -1px;
}
</style>
